import { createContext, useContext, useEffect, useState } from "react";

/**
 * Global GST display mode — one source of truth for the whole app.
 * 'inc'  -> every figure shown includes the 10% GST
 * 'ex'   -> every figure shown is the true cost without tax
 * Persisted to localStorage (same key the Financials grid always used, so
 * existing preferences carry over).
 */
const GstModeContext = createContext(null);

export const GstModeProvider = ({ children }) => {
  const [gstMode, setGstMode] = useState(() => {
    const saved = localStorage.getItem("fin_gst_mode");
    return saved === "ex" ? "ex" : "inc";
  });
  useEffect(() => {
    localStorage.setItem("fin_gst_mode", gstMode);
  }, [gstMode]);
  return <GstModeContext.Provider value={{ gstMode, setGstMode }}>{children}</GstModeContext.Provider>;
};

export const useGstMode = () => {
  const ctx = useContext(GstModeContext);
  const gstMode = ctx?.gstMode === "ex" ? "ex" : "inc";
  const factor = gstMode === "inc" ? 1.1 : 1;
  return {
    gstMode,
    setGstMode: ctx?.setGstMode || (() => {}),
    gstLabel: gstMode === "inc" ? "Inc. GST" : "Ex. GST",
    gstSuffix: gstMode === "inc" ? "(Inc. GST)" : "(Ex. GST)",
    // budgets, quotes and rates are STORED ex GST — these convert between
    // the storage basis and whatever the user has chosen to look at
    fromEx: (v) => (Number(v) || 0) * factor,
    toEx: (v) => (Number(v) || 0) / factor,
  };
};
